import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export enum SpellingTab {
  MyStudents = 'myStudents',
  SpellingRule = 'spellingRule',
  IndividualWords = 'individualWords',
}

export default class WritingLegendsSpellingController extends Controller {
  queryParams = ['sort', 'tab', 'pageNumber', 'rule', 'student']

  @tracked sort = '-total_incorrect'

  @tracked tab = SpellingTab.MyStudents

  @tracked pageNumber = 1

  @tracked rule = ''

  @tracked student = ''
}

declare module '@ember/controller' {
  interface Registry {
    'reporting/ui-scope/writing-legends/spelling': WritingLegendsSpellingController
  }
}
